export const setUserSkills = (payload) => ({type: "SET_USER_SKILLS", payload})
export const setUserTrajectory = (payload) => ({type: "SET_USER_TRAJECTORY", payload})
export const setMyRegion = (payload) => ({type: "SET_USER_REGION", payload})
export const setUser = (payload) => ({type: "SET_USER", payload})
